import {useTranslation} from "react-i18next";
import "moment-timezone";
import {useEffect} from "react";
import IconBool from "components/IconBool";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import OrderByHeaders from "components/ordering/OrderByHeaders";
import {Link} from "react-router-dom";
import useCustomTranslation from "core/customTranslation";
const translations = {
    es: {
        unloads: "Descargas",
    },
    en: {
        unloads: "Unloads",
    },
};

const TableAssetBridge = (props) => {
    const {t: _Tc} = useTranslation("choices");
    const { t: _Tt } = useTranslation("tables");
    const {t: _TC} = useCustomTranslation(translations);
    const stickyHeaderStyle = {
        position: "sticky",
        top: "168px",
        backgroundColor: "white",
    };

    useEffect(() => {
        props.orderingRef.current.setHeaders([
        { name: "UID", attr: 0, direction: "asc", active: true, default: true },
        { name: "UUID", attr: 1, direction: "asc", active: false },
        { name: "TAG", attr: 2, direction: "asc", active: false },
        { name: _Tt("containers.address"), attr: 3, direction: "asc", active: false },
        { name: _Tt("containers.active"), attr: 4, direction: "asc", active: false },
        ]);
    }, []);

    return (
        <table className="table table-striped table-sticky-horizontal">
            <thead>
                <tr style={stickyHeaderStyle}>
                    <OrderByHeaders orderingRef={props.orderingRef} />
                </tr>
            </thead>
            <tbody>
                {props.itemsShown.map((item, index) => (
                    <tr key={index} data-idx={index} onClick={props.onClickRow} className="cursor-pointer">
                        <td>{item.uid}</td>
                        <td>{item.uuids}</td>
                        <td>{item.tag}</td>
                        <td>{item.full_address}</td>
                        <td className="ps-4">
                            <IconBool value={item.active} />
                        </td>
                    </tr>
                ))}
            </tbody>
        </table>
    );
};

export default TableAssetBridge;
